import Work1 from "../../assets/P1.png";
import Work2 from "../../assets/P2.png";
import Work3 from "../../assets/P3.png";

const Menu = [
    {
        id: 1,
        image: Work1,
        title: "Pokedex",
        category: ["API REST", "HTML", "SASS"],
        url: "https://jerry-gzh.github.io/Pokedex/",
        repositoryUrl: "https://github.com/jerry-gzh/Pokedex"
    },
    {
        id: 2,
        image: Work2,
        title: "Pinterest-Clone",
        category: ["HTML", "CSS"],
        url: "https://jerry-gzh.github.io/Proyecto-Pinterest/",
        repositoryUrl: "https://github.com/jerry-gzh/Proyecto-Pinterest"
    },
    {
        id: 3,
        image: Work3,
        title: "Audiophile e-commerce",
        category: ["REACT, Firebase, SASS, Bootstrap"],
        url: "https://jerry-gzh.github.io/Audiophile/",
        repositoryUrl: "https://github.com/jerry-gzh/Audiophile"
    }
];

export default Menu;
